var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 10,
    viewBox: "0 0 14 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.57031 10C4.72266 10 4.875 9.87305 4.875 9.69531V8.67969C4.875 8.52734 4.72266 8.375 4.57031 8.375H2.4375C1.98047 8.375 1.625 8.01953 1.625 7.5625V2.6875C1.625 2.25586 1.98047 1.875 2.4375 1.875H4.57031C4.72266 1.875 4.875 1.74805 4.875 1.57031V0.554688C4.875 0.402344 4.72266 0.25 4.57031 0.25H2.4375C1.0918 0.25 0 1.3418 0 2.6875V7.5625C0 8.9082 1.0918 10 2.4375 10H4.57031ZM7.54102 2.30664L9.52148 4.10938H4.67188C4.31641 4.10938 4.0625 4.38867 4.0625 4.71875V5.53125C4.0625 5.88672 4.31641 6.14062 4.67188 6.14062H9.52148L7.54102 7.96875C7.28711 8.19727 7.28711 8.60352 7.54102 8.83203L8.09961 9.39062C8.32812 9.61914 8.70898 9.64453 8.9375 9.39062L12.7969 5.55664C13.0508 5.32812 13.0508 4.94727 12.7969 4.69336L8.96289 0.884766C8.70898 0.630859 8.32812 0.630859 8.09961 0.884766L7.54102 1.44336C7.28711 1.67188 7.28711 2.07812 7.54102 2.30664Z",
    fill: "#414141"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/Logout.a420e270cb3dac3461ba97b79ed66ed1.svg";
export { ForwardRef as ReactComponent };